(() => {
  const desktop = () => innerWidth >= 1100 && document.querySelector('.collection-grid-section');
  const close = () => {
    document.querySelector('#open_filters_menu')?.classList.remove('show_menu');
    document.body.classList.remove('overflow-hidden','open-filters');
    document.querySelector('.shopify-section-header')?.classList.remove('low_index');
    document.querySelector('.section-announcement')?.classList.remove('low_index');
    document.querySelector('.open_filters')?.setAttribute('aria-expanded','false');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(document.querySelector('.open_filters'));
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('.open_filters,.facets-menu__close,.facets__submit,.facets__reset,.form-menu__mask');
    if (!trigger) return;
    if (trigger.classList.contains('no_submit')) event.preventDefault();
    if (desktop()) return;
    const panel = document.querySelector('.facets-menu');
    if (trigger.classList.contains('open_filters') && !document.body.classList.contains('open-filters')) {
      document.querySelector('#open_filters_menu')?.classList.add('show_menu');
      document.body.classList.add('overflow-hidden','open-filters');
      trigger.setAttribute('aria-expanded','true');
      if (typeof trapFocus === 'function' && panel) trapFocus(panel,panel.querySelector('a,button,input'));
    } else close();
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && document.body.classList.contains('open-filters')) close(); });
  window.addEventListener('resize', () => { if (desktop()) close(); });
})();
